import React, { FC } from 'react';
import classNames from 'classnames';
import cls from './Badge.module.css';

export const Badge = ({ children }) => {
    return <div className={classNames(cls.Badge)}>{children}</div>;
};
